
import Cookies from "js-cookie"
import { deleteAddress } from "@/api/address"
import addressOperation from "@/components/drawer/addressOperation.vue"
import { resetStoreInfo, getCurrentAddress, clearBeforeSet, getDeliveryMethod } from "@/utils/utils"
import { getCommonParam } from "@/plugins/env"
export default {
  components: { addressOperation },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      addressList: [],
      activeItem: {},
      readyConfim: false,
      curAddress: {},
      addressOperationVisible: false,
      addressOperationTitle: "",
      addressOperationType: "",
      curChooseAddress: null
    }
  },
  computed: {},
  watch: {
    list: {
      handler(val) {
        this.addressList = val
        this.activeItem = this.curAddress = getCurrentAddress() || {}
        this.readyConfim = getDeliveryMethod() === "clickCollect"
      },
      immediate: true
    }
  },
  created() {},
  mounted() {},
  methods: {
    isActive(item) {
      return this.activeItem.id && item.id && this.activeItem.id === item.id
    },
    toggleSelect(item) {
      this.activeItem = item
      this.readyConfim = getDeliveryMethod() === "clickCollect" ? true : item.id !== this.curAddress.id
    },
    async handleSelectAddress() {
      if (!this.readyConfim) {
        return
      }
      const loading = this.$loading({
        background: "rgba(0, 0, 0, 0)"
      })
      await resetStoreInfo(this.activeItem)
      loading.close()
      this.$emit("close")
    },
    handleAddAddress() {
      // this.handleClose()
      this.addressOperationType = "add"
      this.addressOperationVisible = true
    },
    handleRemoveAddress(item) {
      this.curChooseAddress = item
      const currentAddress = getCurrentAddress()
      const isCurrent = currentAddress && currentAddress.id == item.id
      this.$messageBox
        .open({
          title: this.$t("address.removeThisAddress"),
          message: this.$t("address.actionCannotUndone"),
          cancelText: this.$t("address.keepAddress"),
          confirmText: this.$t("address.remove"),
          showClose: false,
          disMaskClick: true
        })
        .then(async () => {
          try {
            // delete
            await deleteAddress({ param: JSON.stringify({ id: item.id }) })
            const accountInfo = await this.$store.dispatch("getLoginInfo")
            this.$message({
              message: this.$t("address.addressRemoved"),
              type: "success"
            })
            const { shipmentType } = getCommonParam()
            if (shipmentType == 2) {
              this.$emit("update")
            } else {
              if (isCurrent) {
                if (accountInfo && accountInfo.address && accountInfo.address.length) {
                  // 删除当前选中地址，默认使用第一条重置
                  resetStoreInfo(accountInfo.address[0])
                  this.$emit("close")
                } else {
                  console.log("用户无地址")
                  clearBeforeSet()
                  this.$emit("close")
                  window.location.reload()
                }
              } else {
                this.$emit("update")
              }
            }
          } catch (error) {
            // loading.close()
          }
        })
        .catch(res => {
          console.log(res)
        })
    },
    handleEditAddress(item) {
      // this.handleClose()
      this.addressOperationType = "edit"
      this.curChooseAddress = item
      this.addressOperationVisible = true
    },
    handleClose() {
      this.curChooseAddress = null
      this.$emit("close")
    },
    onAddressClose(param) {
      this.addressOperationVisible = false
      if (param) {
        this.$emit("close")
      }
    },
    onAddressSave() {},
    onAddressBack() {
      this.addressOperationVisible = false
      this.$emit("back")
    },
    onAddressUpdate() {
      this.addressOperationVisible = false
      this.$emit("update")
    }
  }
}
